const SideGoogleAds = () => {
  return (
      <div className="container" style={{ textAlign: "center"}}>
        <div className="googls-adds">
          <div className="CMSBanner Banner gadsbanner" id="div-gpt-ad-1628625083968-0" style={{ minWidth: 300, minHeight: 250, marginBottom: "7px", padding: "0px" }}></div>
          <div className="CMSBanner Banner gadsbanner" id="div-gpt-ad-1628625213078-0" style={{ minWidth: 300, minHeight: 250, marginBottom: "7px", padding: "0px" }}></div>
        </div>
      </div>
  );
};

export default SideGoogleAds;
